import { LoyaltyStatus } from '@/components/LoyaltyStatus';
import { useGetLoyaltyStatus } from '@/query/queries/loyalty/useGetLoyaltyStatus';
import { Preloader } from '@/components/Preloader';
import { MiniFaqs, MINIFAQ_SOURCES } from '@/containers/MiniFaqs';
import { LoyaltyAllStatuses } from './components/LoyaltyAllStatuses';
import s from './index.module.scss';

const LoyaltyProgramPage = () => {
  const { data: status, isLoading } = useGetLoyaltyStatus();

  return (
    <div className={s.page}>
      <div className="container-inner">
        <div className={s.content}>
          {isLoading || !status ? (
            <Preloader />
          ) : (
            <>
              <LoyaltyStatus />
              <LoyaltyAllStatuses currentLevel={status.level_slug} />
            </>
          )}
        </div>
        <MiniFaqs source={MINIFAQ_SOURCES.loyalty} />
      </div>
    </div>
  );
};

export default LoyaltyProgramPage;
